import { BranchCreatePage } from '@/features/branch/pages/BranchCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/branch/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["branch.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BranchCreatePage,
})
